import { api } from '@/lib/axios'

/**
 * AP-37 Detailblatt N 8. (N8) — **Assistent** (`/calculations/:id/assistant`) und
 * **Einstellungen → Kalkulation → KI** (`/calculation-settings/ai`), Baustein `CALCULATION.AI`.
 */
export interface AssistentAktion {
  type: 'START_TASK' | 'OPEN_REQUESTS'
  capability?: string
  label: string
}

export interface AssistentEintrag {
  role: 'user' | 'assistant'
  text: string
  at: string
  tokens?: number
  tools?: string[]
  runId?: string
  actions?: AssistentAktion[]
}

export interface AssistentVerlauf {
  status: 'IDLE' | 'RUNNING' | 'FAILED'
  error: string | null
  updatedAt: string | null
  messages: AssistentEintrag[]
}

export interface KiEinstellungen {
  assistantEnabled: boolean
  assistantKeySource: 'TENANT' | 'CENTRAL'
  assistantConfirmedAt: string | null
  consentVersion: string | null
  consentAt: string | null
  consentCurrent: boolean
  consentText: string
  consentTextVersion: string
  assistantConfirmationText: string
  planPageLimit: number
  folderDeleteDays: number
  tenantKey: boolean
  tenantKeySuffix: string | null
  aiEnabled: boolean
  provider: string
  /** N1: Fähigkeiten, die es eingebaut gibt, ihr Schalter und ihr Modell */
  builtinCapabilities: string[]
  capabilities: Record<string, boolean> | null
  models: Record<string, string> | null
  availableModels: { models: string[]; defaultModel: string } | null
  tenantModel: string | null
  /** AP-43: je Fähigkeit das Modell, das ohne eigenes Modell je Fähigkeit liefe (Mandant, Vorgabe von Symphenia, Code). */
  defaultModels?: Partial<Record<string, string>>
  quota: { limit: number; used: number; warn: boolean; exhausted: boolean }
}

export type KiEinstellungenAenderung = Partial<Pick<KiEinstellungen, 'assistantEnabled' | 'assistantKeySource' | 'planPageLimit' | 'folderDeleteDays'>> & {
  capabilities?: Record<string, boolean>
  models?: Record<string, string>
  confirmAssistant?: boolean
  consent?: boolean
  apiKey?: string
  removeApiKey?: boolean
}

const pfad = (id: string) => `/calculations/${id}/assistant`

export const fetchAssistent = (id: string) => api.get<{ data: AssistentVerlauf }>(pfad(id)).then((r) => r.data.data)
export const frageAssistent = (id: string, text: string) => api.post<{ data: AssistentVerlauf }>(pfad(id), { text }).then((r) => r.data.data)
export const leereAssistent = (id: string) => api.delete<{ data: AssistentVerlauf }>(pfad(id)).then((r) => r.data.data)

export const fetchKiEinstellungen = () => api.get<{ data: KiEinstellungen }>('/calculation-settings/ai').then((r) => r.data.data)
export const speichereKiEinstellungen = (dto: KiEinstellungenAenderung) =>
  api.put<{ data: KiEinstellungen }>('/calculation-settings/ai', dto).then((r) => r.data.data)
